const lbaPerDiemFileUploader = angular.module('app.lbaPerDiemFileUploader', [
    require('../lbaDate').name
]);

lbaPerDiemFileUploader.controller('lbaPerDiemFileUploaderCtrl', require('./lbaPerDiemFileUploaderCtrl'));
lbaPerDiemFileUploader.directive('lbaPerDiemFileUploader', require('./lbaPerDiemFileUploaderDir'));
lbaPerDiemFileUploader.service('perDiemService', require('../../services/perDiemService'));

export default lbaPerDiemFileUploader;



// WEBPACK FOOTER //
// ./src/components/lbaPerDiemFileUploader/index.js